export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20shapes%20with%20soft%20flowing%20curves%20in%20gentle%20terracotta%20peach%20and%20cream%20tones%2C%20elegant%20gradient%20texture%2C%20modern%20minimalist%20composition%20with%20delicate%20layered%20overlapping%20circles%20and%20arches%2C%20airy%20atmospheric%20feel%2C%20soft%20diffused%20light%2C%20organic%20smooth%20geometric%20elements%2C%20editorial%20design%20aesthetic%2C%20harmonious%20warm%20palette&width=1800&height=800&seq=superbuy-hero-fresh-v2&orientation=landscape"
          alt="Superbuy Sheet shopping discovery platform background"
          title="Superbuy Sheet - Smart Shopping Platform"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>

      <div className="relative z-10 w-full text-center px-6">
        <div className="max-w-3xl mx-auto">
          <p className="text-sm md:text-base font-medium tracking-widest uppercase text-background-50/90 mb-4">
            Discover &bull; Organize &bull; Shop Smarter
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
            Superbuy Sheet
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
            Your ultimate shopping discovery platform. Browse thousands of curated products
            across 14 categories — from shoes to accessories, all organized for effortless shopping.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-base rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Superbuy Sheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold text-base rounded-full border border-background-50/30 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}